import React, { useState, useEffect } from "react";
import Calendar from "./Calendar.jsx"; // Ihr bestehender Calendar
import MobileCalendar from "./MobileCalendar.jsx"; // Neue Mobile Component

const CalendarWrapper = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Render Mobile oder Desktop Calendar
  if (isMobile) {
    return <MobileCalendar {...props} />;
  } else {
    return <Calendar {...props} />;
  }
};

export default CalendarWrapper;